
<div mat-dialog-title>Securities cannot be deleted<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>

<mat-dialog-content>
  <mat-card class="warn block">
    <mat-card-title class="warn" style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">{{totalCount}} selected securities cannot be deleted. See explanations
    below.</mat-card-title>
  </mat-card>

  <div class="block">To delete this security, you must remove it from these associations</div>

  @if (!isUiTest) {
    <div>
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'240px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [frameworkComponents] = 'frameworkComponents'
        [rowData] = 'data.deleteSecurities'
      (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions >
  <button (click)="export()" class="btn-medium-tertiary export-btn">Export</button>
  <button (click)="close()" class="btn-medium-primary">Close</button>
</mat-dialog-actions>

